<template>
  <div class="dropdown" v-if="ous.length === 1">
    <ImageAuth
      v-if="ous[0]?.picture?.id"
      :imageId="Number(ous[0].picture.id)"
    />
    <img
      v-else
      :src="require('@/assets/img/company-default-img.png')"
      alt="Company"
    />
    <span class="ps-2 text-dark text-bold">{{ ous[0]?.name }}</span>
  </div>
  <div class="dropdown mt-3" v-else>
    <a
      class="btn btn-outline dropdown-toggle p-0 rounded-0"
      data-bs-toggle="dropdown"
      id="companyListDropdown"
    >
      <ImageAuth
        v-if="selectedOu?.picture?.id"
        :imageId="Number(selectedOu.picture.id)"
      />
      <img
        v-else
        :src="require('@/assets/img/company-default-img.png')"
        alt="Company"
      />

      <span class="ps-2 text-dark">{{ selectedOu?.name }}</span>
    </a>
    <ul class="dropdown-menu" aria-labelledby="companyListDropdown">
      <li v-for="ou in ous" :key="ou.id">
        <a class="dropdown-item" @click="selectOu(ou)">
          <ImageAuth v-if="ou?.picture?.id" :imageId="Number(ou.picture.id)" />
          <img
            v-else
            :src="require('@/assets/img/company-default-img.png')"
            alt="Company"
          />
          <span class="ps-2 text-dark">{{ ou.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import ImageAuth from "@/components/ImageAuth.vue";
import axiosInstance from "@/services/AxiosTokenInstance";
import { useCompanyStore } from "@/stores/companyStore";
import { useAuthStore } from "@/stores";

// const companyStore = useCompanyStore();
// companyStore.selectCompany(this.selectedOu);

export default {
  name: "CurrentCompany",
  components: {
    ImageAuth,
  },
  data() {
    return {
      ous: [],
      selectedOu: {
        picture: {},
      },
      user: useAuthStore().user,
      companyStore: useCompanyStore(),
    };
  },
  watch: {
    // Watch for changes in the refresh trigger
    "companyStore.refreshTrigger"() {
      this.getOus();
    },
  },
  mounted() {
    if (this.user) {
      this.getOus();
    }

    const savedCompany = JSON.parse(localStorage.getItem("selectedCompany"));
    if (savedCompany) {
      this.selectedOu = savedCompany;
    }
  },
  methods: {
    async getOus() {
      let queryParams = {
        itemsPerPage: 100,
        page: 1,
        "order[name]": "ASC",
      };

      try {
        const response = await axiosInstance.get("ous", {
          params: queryParams,
        });

        this.ous = response.data["hydra:member"];

        // Only set company if not already set (e.g., fresh login already set it)
        if (!this.selectedOu || !this.selectedOu.id) {
          await this.selectOu(this.ous[0]);
        } else {
          // Company already selected (from localStorage during login)
          // Just update the company object with full data
          const fullCompany = this.ous.find(
            (ou) => ou.id === this.selectedOu.id,
          );
          if (fullCompany) {
            this.selectedOu = fullCompany;
            const companyStore = useCompanyStore();
            companyStore.selectCompany(fullCompany);
            // Fetch latest roles from API instead of using cached keyUsers
            await companyStore.fetchCompanyRoles(
              fullCompany.id,
              this.user.user_id,
            );
          }
        }
      } catch (error) {
        console.error(error);
      }
    },

    async selectOu(ou) {
      this.selectedOu = ou;

      const companyStore = useCompanyStore();

      // Update store with selected company
      companyStore.selectCompany(this.selectedOu);

      // Fetch latest roles from API instead of using cached keyUsers
      await companyStore.fetchCompanyRoles(ou.id, this.user.user_id);
    },
  },
};
</script>
